const redirectTo = (page: string): void => {
	window.location.assign(page);
};

export default redirectTo;
